import { logUsage } from 'owa-analytics';

const enum Component {
    AppHost = 'AppHost',
}

const enum Scenario {
    Usage = 'Usage',
    Failure = 'Failure',
    RenderPerf = 'RenderPerf',
}

type AppHostRenderPerf = {
    appId: string;
    phase: 'render' | 'mount';
    actualDuration: number;
    baseDuration: number;
};
type AppHostFailure = {
    error?: 'Uncaught_Error' | 'UI_Error';
    reason?: string;
};
type AppHostTelemetryParams = AppHostRenderPerf | AppHostFailure;

export function log(
    params: AppHostTelemetryParams,
    component: Component = Component.AppHost /* sensitive default for current use case, this might be removed */,
    scenario: Scenario = Scenario.RenderPerf /* sensitive default for current use case, this might be removed */
) {
    logUsage(`${component}_${scenario.toString()}`, params);
}

export function logError(params: AppHostTelemetryParams, component: Component = Component.AppHost) {
    log(params, component, Scenario.Failure);
}
